import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateNotInFutureValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value === null || typeof control.value !== 'string') {
    return null;
  }

  if (new Date(control.value) > new Date()) {
    return { dateInFuture: true };
  }

  return null;
}
